import { NgModule } from '@angular/core';
import { PartymgrComponent } from './partymgr.component';
import { GeoLocationComponent } from './customers/customer/geo-location/geo-location.component';
import { PartymgrRoutingModule } from './partymgr-routing.module';
import { CommonModule } from '@angular/common';
import { CustomerModule } from './customers/customer.module';
import { SupplierModule } from './suppliers/supplier.module';
import { EmployeeModule } from './employees/employee.module';
import { NbCardModule } from '@nebular/theme';



@NgModule({
  declarations: [
    PartymgrComponent,
    GeoLocationComponent
  ],
  imports: [
    CommonModule,
    NbCardModule,
    CustomerModule,
    SupplierModule,
    EmployeeModule,
    PartymgrRoutingModule
  ],
  exports: [
    PartymgrComponent,
    CustomerModule
  ]
})
export class PartymgrModule { }
